"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var variables_1 = require("../../../style/variables");
var input_1 = require("../../input");
var ButtonGroup_1 = require("./ButtonGroup");
var styles = {
    base: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        whiteSpace: 'nowrap',
        '&:not(:first-of-type)': {
            marginLeft: -1,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        },
        '&:not(:last-of-type)': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
        ':focus-visible:enabled': {
            boxShadow: 'none',
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
        ':active:enabled': {
            boxShadow: 'none',
        },
        ':hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
        ':disabled': {
            color: "var(" + variables_1.TextColor.DISABLED + ")",
            background: "var(" + variables_1.RootColor.White + ")",
            borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        },
    }),
    selected: react_1.css({
        zIndex: 2,
        backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_5 + ")",
        color: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
        borderColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
        ':hover:enabled': {
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_5 + ")",
            color: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
            borderColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
        },
        ':focus-visible:enabled': {
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_5 + ")",
            color: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
            borderColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
        },
        ':disabled': {
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_6 + ")",
            color: "var(" + variables_1.ThemeColor.Primary.LIGHT_2 + ")",
            borderColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_3 + ")",
        },
        '&:not(:first-of-type)': {
            borderLeftWidth: 1,
        },
    }),
};
function ButtonGroupButton(_a) {
    var value = _a.value, props = __rest(_a, ["value"]);
    var groupContext = react_2.useContext(ButtonGroup_1.ButtonGroupContext);
    return (react_1.jsx(input_1.Button, __assign({ css: [
            styles.base,
            value === groupContext.value ? styles.selected : undefined,
        ], disabled: groupContext.disabled }, props, { onClick: function (e) {
            var _a, _b;
            (_a = groupContext.onChange) === null || _a === void 0 ? void 0 : _a.call(groupContext, value);
            (_b = props.onClick) === null || _b === void 0 ? void 0 : _b.call(props, e);
        }, hierarchy: "secondary", size: "default" })));
}
exports.default = ButtonGroupButton;
